var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v(" "+_vm._s(_vm.content)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }